export default {"src":"/_next/static/media/dalle.0c89e55b.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};